import React, { Fragment } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconThreeDotsLoadingDark } from 'images/general/three-dots-loading-dark.svg';

import { ReactComponent as IconElevatorOff } from 'images/device/status-icon/elevator-off.svg';
import { ReactComponent as IconElevatorBlack } from 'images/device/status-icon/elevator-black.svg';
import { ReactComponent as IconElevatorHinavaSymbol } from 'images/device/symbol/hinava_gradient/elevator.svg';


import './All.scss'


export default function ElevatorControl({ device, darkerBorder }) {
    const s = useLocalizedStrings();

    const containerClass = device.active ?
        "device-detail-control with-flex active" : "device-detail-control with-flex inactive";

    return (
        <Fragment>
            <div className={containerClass}>
                <div className={"elevator-control-box" + (darkerBorder ? " darker" : "")}>
                    <ElevatorSingleButton s={s} showStates={true}
                        onClickH={() => { device.changeState({ state1: true }) }} />

                    {device.state1 ? <ElevatorStatePanel s={s}
                        onClickH={() => { device.changeState({ state1: false }) }}
                        waitingForChangeState={device.waitingForChangeState["state1"]} /> : null}
                </div>
            </div>
        </Fragment>

    )
}

export function ElevatorSingleButton({ onClickH, s, showStates }) {
    if (!showStates) {
        return (
            <div className="device-button"
                style={{ width: 65 }}> {/* set width > label's length, for better placement of buttons and not changing on state changes*/}
                <IconElevatorHinavaSymbol className="icon" />
                <div className="status-placeholder" />
            </div>
        );
    } else {
        return (
            <div className="device-button"
                style={{ width: 65 }}> {/* set width > label's length, for better placement of buttons and not changing on state changes*/}
                <IconElevatorOff className="device-button-icon-off" />
                <div className="device-off-label status-text-or-icon">{s.off}</div>
                <div className="device-on-click-overlay" onClick={onClickH} />
            </div>
        );
    }
}

export function ElevatorStatePanel({ waitingForChangeState, s, forDeviceList, onClickH }) {
    const shouldShowWaiting = forDeviceList && waitingForChangeState && !waitingForChangeState.ignoreWaiting;

    return (
        <div className={"elevator-panel full"} onClick={onClickH} >
            <IconElevatorBlack className="icon" />

            <div className="label">{s.elevator.calling}</div>

            {
                !shouldShowWaiting ?
                    (forDeviceList ? <div className="info">{s.elevator.tapToStop}</div> : null)
                    : <IconThreeDotsLoadingDark className="curtain-dots-icon" />
            }
        </div>
    );
}